class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.currentMethod = "delivery"; // Default method
    this.updateCartCountBubble();
    // this.pickUpId = this.querySelector('[data-method="pickup"]')?.getAttribute("data-id") || null;
    this.pickUpId = this.getAttribute("data-pickup-item") || null;

    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    // this.updateCartCountBubble();

    // Always remove pickup item from cart
    this.removePickupItem();

    // Handle cart page redirection
    this.handleCartOpenRequest();

    // Restore state on load
    this.restoreState();

    // Handle clicks
    this.addEventListener("click", (event) => {
      const target = event.target;

      if (target.classList.contains("click-collect__switch")) {
        this.handleSwitchClick(target);
      }

      if (target.closest(".click-collect__store")) {
        const store = target.closest(".click-collect__store");
        this.handleStoreSelection(store);
      }

      // Add event listener for the checkout button
      if (target.name === "checkout") {
        this.handleCheckoutClick(event);
      }
    });

    // Restore state on cart drawer open
    this.addEventListener("transitionend", (event) => {
      if (event.target === this && this.classList.contains("active")) {
        this.restoreState();
      }
    });

    this.onCartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.onCartUpdate, (event) => {
      this.restoreState();
    });

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      this.restoreState();
    });
  }

  async updateCartCountBubble() {
    try {
      const cartData = await this.getCart();

      if (!cartData) {
        console.error("Failed to fetch cart data for updating cart count.");
        return;
      }

      const totalCount = cartData.items.reduce((count, item) => {
        if (item.id.toString() !== this.pickUpId) {
          return count + item.quantity;
        }
        return count;
      }, 0);

      const cartCountBubble = document.querySelector(".cart-count-bubble > span[aria-hidden='true']");
      const cartCountVisuallyHidden = document.querySelector(".cart-count-bubble > .visually-hidden");

      if (cartCountBubble && cartCountVisuallyHidden) {
        cartCountBubble.textContent = totalCount;
        cartCountVisuallyHidden.textContent = `${totalCount} item${totalCount !== 1 ? "s" : ""}`;
      } else {
        console.warn("Cart count bubble elements not found in DOM.");
      }
    } catch (error) {
      console.error("Error updating cart count:", error);
    }
  }

  handleCartOpenRequest() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get("cart") === "open") {
      this.updateCartCountBubble();
      this.open();
      // Update the URL to remove the cart query parameter
      const newURL = window.location.origin + window.location.pathname;
      history.replaceState({}, document.title, newURL);
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState, triggerOpen = true) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (triggerOpen) {
        this.open();
      }

      // Automatically check stock for the selected store when drawer opens
      const selectedStore = this.querySelector(".click-collect__store.selected");
      if (selectedStore) {
        const storeName = selectedStore.getAttribute("data-store");
        this.checkCartStockForStore(storeName);
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-drawer",
        selector: "#cart-click-collect",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Click and Collect
  async updateCartAttributesOnCheckout() {
    try {
      // Retrieve state from localStorage
      const savedState = JSON.parse(localStorage.getItem("clickAndCollectState")) || {};
      const attributes = {};

      // Check if the method is "pickup"
      if (savedState["method"] === "pickup") {
        attributes["cnc-fulfilment-method"] = savedState["cnc-fulfilment-method"] || "store";
        attributes["cnc-store-name"] = savedState["cnc-store-name"] || "";
        attributes["cnc-outlet"] = savedState["cnc-outlet"] || "";
      } else {
        // Reset attributes if the method is "delivery"
        attributes["cnc-fulfilment-method"] = "";
        attributes["cnc-store-name"] = "";
        attributes["cnc-outlet"] = "";
      }

      // Prepare the body
      const body = JSON.stringify({ attributes });

      // Send the request to update cart attributes
      const response = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{ body },
      });

      if (!response.ok) {
        throw new Error(`Failed to update cart attributes. Status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error updating cart attributes on checkout:", error);
    }
  }

  async handleCheckoutClick(event) {
    event.preventDefault();

    const checkoutButton = event.target;
    checkoutButton.disabled = true;
    checkoutButton.classList.add("loading");
    checkoutButton.querySelector(".loading__spinner").classList.remove("hidden");

    let success = true;

    try {
      // Update cart attributes based on localStorage
      await this.updateCartAttributesOnCheckout();

      if (this.currentMethod === "pickup") {
        const pickupSuccess = await this.ensurePickupItem();

        if (!pickupSuccess) {
          success = false;
          throw new Error("Failed to add pickup item to cart.");
        }
      }
    } catch (error) {
      console.error("Error during checkout process:", error);
      alert("An error occurred during checkout. Please try again.");
      success = false;
    } finally {
      checkoutButton.disabled = false;
      checkoutButton.classList.remove("loading");
      checkoutButton.querySelector(".loading__spinner").classList.add("hidden");

      if (success) {
        window.location.href = "/checkout";
      }
    }
  }

  async refreshCartDrawer() {
    try {
      // Fetch updated cart sections
      const response = await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble,cart-click-collect`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to refresh cart drawer. Status: ${response.status}`);
      }

      const parsedState = await response.json();

      // Format data for renderContents
      const transformedState = {
        sections: parsedState,
      };

      if (typeof this.renderContents === "function") {
        this.renderContents(transformedState, false);
        this.restoreState();
      } else {
        console.error("renderContents method not found on cart-drawer.");
      }
    } catch (error) {
      console.error("Error refreshing cart drawer:", error);
    }
  }

  async getCart() {
    try {
      const response = await fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        console.error("Failed to fetch cart data.");
        return null;
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return null;
    }
  }

  async ensurePickupItem() {
    if (!this.pickUpId) {
      console.error("Pickup item ID not set. Cannot proceed.");
      return false;
    }

    const response = await fetch(`${routes.cart_add_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: this.pickUpId, quantity: 1 }),
    });

    if (response.ok) {
      // console.log("Pickup item added successfully.");
      this.refreshCartDrawer();
      return true;
    } else {
      console.error("Failed to add pickup item.", await response.text());
      return false;
    }
  }

  async ensurePickupItemRemoved() {
    if (!this.pickUpId) {
      console.warn("Pickup item ID not set. Skipping removal.");
      return;
    }

    try {
      const cartData = await this.getCart(); // Fetch cart data
      const hasPickupItem = cartData.items.some((item) => item.id.toString() === this.pickUpId);

      if (hasPickupItem) {
        // console.log("Removing pickup item...");
        const response = await fetch(`${routes.cart_change_url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: this.pickUpId, quantity: 0 }),
        });

        if (response.ok) {
          // console.log("Pickup item removed successfully.");
        } else {
          console.error("Failed to remove pickup item.", await response.text());
        }
      } else {
        // console.log("Pickup item is not in the cart. No action needed.");
      }
    } catch (error) {
      console.error("Error ensuring pickup item is removed:", error);
    }
  }

  async removePickupItem() {
    // console.log("Checking and removing pickup item from cart...");

    if (!this.pickUpId) {
      // console.warn("Pickup item ID not set. Skipping removal.");
      return true;
    }

    try {
      const cartData = await this.getCart();

      if (!cartData) {
        console.error("Failed to fetch cart data. Cannot remove pickup item.");
        return false;
      }

      const itemExists = cartData.items.some((item) => item.id.toString() === this.pickUpId);

      if (!itemExists) {
        // console.log("Pickup item does not exist in the cart. Skipping removal.");
        return true;
      }

      const response = await fetch(`${routes.cart_change_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: this.pickUpId, quantity: 0 }),
      });

      if (response.ok) {
        // console.log("Pickup item removed successfully.");
        this.refreshCartDrawer();
        return true;
      } else {
        console.error("Failed to remove pickup item.", await response.text());
        return false;
      }
    } catch (error) {
      console.error("Error while removing pickup item:", error);
      return false;
    }
  }

  async checkCartStockForStore(storeName) {
    const API_URL = "https://shopify.retailexpress.com.au/api/shopify_stores/beyond-skate-city/outlets";

    if (this.currentMethod === "delivery") {
      // Reset the cart drawer if the method is delivery
      this.resetCartDrawer();
      return;
    }

    const cartItems = this.querySelectorAll(".cart-item");
    const productIds = Array.from(cartItems)
      .map((item) => item.getAttribute("data-id"))
      .filter(Boolean); // Collect product IDs from cart items

    if (!productIds.length) {
      return; // Exit if there are no product IDs
    }

    try {
      const response = await fetch(`${API_URL}?variant_ids=${productIds.join(",")}`);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      const normalizeStoreName = (name) => name.toLowerCase().trim().replace(/\s+/g, "_");

      let allItemsInStock = true;

      // Iterate through all click-and-collect stores in the DOM
      const stores = this.querySelectorAll(".click-collect__store");
      stores.forEach((store) => {
        const storeNameAttr = store.getAttribute("data-store");
        const storeStatus = store.querySelector(".store__status");
        if (!storeStatus) return; // Skip if there's no store status element

        storeStatus.className = "store__status"; // Reset store status classes
        const storeData = data.outlets.find((outlet) => normalizeStoreName(outlet.name) === normalizeStoreName(storeNameAttr));

        if (!storeData) {
          // If no store data is found, mark as unavailable
          storeStatus.classList.add("unavailable");
          return;
        }

        let allAvailable = true;
        let hasStock = false;

        // Check stock for each product in the cart
        cartItems.forEach((item) => {
          const productId = item.getAttribute("data-id");
          const stockQuantity = storeData.stock[productId] || 0; // Get stock quantity for the product

          if (stockQuantity > 0) {
            hasStock = true; // At least one product has stock
          } else {
            allAvailable = false; // Some products are out of stock
          }
        });

        // Update store status classes based on stock availability
        if (!hasStock) {
          storeStatus.classList.add("unavailable");
        } else if (!allAvailable) {
          storeStatus.classList.add("low-stock");
        } else {
          storeStatus.classList.add("available");
        }

        // Save information for the currently selected store to localStorage
        if (storeNameAttr === storeName) {
          const savedState = JSON.parse(localStorage.getItem("clickAndCollectState")) || {};

          // Update localStorage only if the store data has changed
          if (savedState["cnc-store-name"] !== storeData.name || savedState["cnc-outlet"] !== storeData.external_id) {
            savedState["cnc-fulfilment-method"] = "store"; // Set the fulfillment method to store
            savedState["cnc-store-name"] = storeData.name; // Store the store name
            savedState["cnc-outlet"] = storeData.external_id; // Store the external ID of the store

            localStorage.setItem("clickAndCollectState", JSON.stringify(savedState));
            // console.log("Updated LocalStorage with selected store info:", savedState);
          }
        }
      });

      // Update the stock status of cart items and enable/disable the checkout button
      const selectedOutlet = data.outlets.find((outlet) => normalizeStoreName(outlet.name) === normalizeStoreName(storeName));
      this.updateCartItemsStock(selectedOutlet, cartItems, allItemsInStock);
    } catch (error) {
      console.error("Error checking stock:", error); // Log any errors encountered
    }
  }

  updateCartItemsStock(storeData, cartItems, allItemsInStock) {
    if (!storeData) {
      console.error("No data available for the selected store.");
      return;
    }

    let allAvailable = true;

    cartItems.forEach((item) => {
      const productId = item.getAttribute("data-id");
      const stockQuantity = storeData.stock[productId] || 0;

      const isOnlineOnly = this.isOnlineOnly(item);
      const isPickupOnly = item.hasAttribute("pickup-only");

      // Create or reuse stock status element
      let stockElement = item.querySelector(".cart-item__stock") || document.createElement("p");
      if (!item.querySelector(".cart-item__stock")) {
        stockElement.classList.add("cart-item__stock");
        item.querySelector(".cart-item__details")?.prepend(stockElement);
      }

      // Online-only item
      if (isOnlineOnly) {
        stockElement.textContent = "Online only";
        stockElement.classList.remove("unavailable", "pickup-only");
        stockElement.classList.add("online-only");
        return;
      }

      // Pickup-only item
      if (isPickupOnly) {
        if (stockQuantity > 0) {
          stockElement.textContent = "Pickup only";
          stockElement.classList.remove("unavailable", "online-only");
          stockElement.classList.add("pickup-only");
        } else {
          stockElement.textContent = "Unavailable";
          stockElement.classList.remove("online-only");
          stockElement.classList.remove("pickup-only");
          stockElement.classList.add("unavailable");
          allAvailable = false;
        }
        return;
      }

      // Normal item
      if (stockQuantity > 0) {
        stockElement.textContent = "";
        stockElement.classList.remove("unavailable", "online-only", "pickup-only");
      } else {
        stockElement.textContent = "Unavailable";
        stockElement.classList.add("unavailable");
        allAvailable = false;
      }
    });

    // Update checkout button state
    const checkoutButton = this.querySelector("[type='submit']");
    if (checkoutButton) {
      checkoutButton.toggleAttribute("disabled", !allAvailable);
      checkoutButton.classList.toggle("disabled", !allAvailable);
    }
  }

  resetCartDrawer() {
    const stores = this.querySelectorAll(".click-collect__store");
    stores.forEach((store) => {
      const storeStatus = store.querySelector(".store__status");
      if (storeStatus) storeStatus.className = "store__status";
      store.classList.remove("selected");
    });

    const cartItems = this.querySelectorAll(".cart-item");
    cartItems.forEach((item) => {
      const stockElement = item.querySelector(".cart-item__stock");
      const isOnlineOnly = this.isOnlineOnly(item);
      if (isOnlineOnly && stockElement) {
        stockElement.textContent = "Online only";
        stockElement.classList.remove("unavailable");
        stockElement.classList.add("online-only");
      } else if (stockElement) {
        stockElement.textContent = "";
        stockElement.classList.remove("unavailable");
      }
    });

    this.querySelector("[type='submit']")?.removeAttribute("disabled");
    this.querySelector("[type='submit']")?.classList.remove("disabled");
  }

  toggleSwitches(currentMethod, isOnlineOnly = false, hasPickupOnly = false) {
    const switches = this.querySelectorAll(".click-collect__switch");

    switches.forEach((switchElement) => {
      const targetMethod = switchElement.getAttribute("data-target");

      // Reset state first
      switchElement.removeAttribute("disabled");
      switchElement.classList.remove("hidden");

      // If there are pickup-only items, hide/disable Delivery switch
      if (hasPickupOnly && targetMethod === "delivery") {
        switchElement.setAttribute("disabled", true);
        switchElement.classList.add("hidden");
        return;
      }

      // If there are online-only items, hide/disable Pickup switch
      if (isOnlineOnly && targetMethod === "pickup") {
        switchElement.setAttribute("disabled", true);
        switchElement.classList.add("hidden");
        return;
      }
    });
  }

  isOnlineOnly(items) {
    const elements = Array.isArray(items) || items instanceof NodeList ? Array.from(items) : [items];
    return elements.some((item) => item.hasAttribute("online-only"));
  }

  hasPickupOnly(items) {
    const elements = Array.isArray(items) || items instanceof NodeList ? Array.from(items) : [items];
    return elements.some((item) => item.hasAttribute("pickup-only"));
  }

  restoreState() {
    const cartItems = this.querySelectorAll(".cart-item");
    const isOnlineOnly = this.isOnlineOnly(cartItems);
    const hasPickupOnly = this.hasPickupOnly(cartItems);

    const savedState = JSON.parse(localStorage.getItem("clickAndCollectState")) || {};
    let savedMethod = savedState.method || "delivery";
    let savedStore = savedState.store || null;

    // Force method based on item types
    if (hasPickupOnly) {
      savedMethod = "pickup";
    } else if (isOnlineOnly) {
      savedMethod = "delivery";
    }

    // Restore method UI
    const methodElements = this.querySelectorAll("[data-method]");
    methodElements.forEach((element) => {
      element.classList.remove("active");
    });

    const methodElement = this.querySelector(`[data-method="${savedMethod}"]`);
    if (methodElement) {
      methodElement.classList.add("active");
      this.currentMethod = savedMethod;
    }

    if (this.currentMethod === "pickup") {
      const stores = this.querySelectorAll(".click-collect__store");

      // If there is no saved store, fall back to the first one
      if (!savedStore && stores.length > 0) {
        savedStore = stores[0].getAttribute("data-store");
      }

      // Update store selection
      stores.forEach((store) => {
        const storeName = store.getAttribute("data-store");
        store.classList.toggle("selected", storeName === savedStore);
      });

      // Persist normalized state
      this.updateClickAndCollectState(this.currentMethod, savedStore || null);

      // Trigger stock check for the active store
      if (savedStore) {
        this.checkCartStockForStore(savedStore);
      }
    } else {
      savedState["cnc-fulfilment-method"] = "";
      savedState["cnc-store-name"] = "";
      savedState["cnc-outlet"] = "";
      savedState["method"] = this.currentMethod;

      localStorage.setItem("clickAndCollectState", JSON.stringify(savedState));
      this.resetCartDrawer();
    }

    this.toggleSwitches(this.currentMethod, isOnlineOnly, hasPickupOnly);
  }

  handleSwitchClick(button) {
    const targetMethod = button.getAttribute("data-target");

    const cartItems = this.querySelectorAll(".cart-item");
    const isOnlineOnly = this.isOnlineOnly(cartItems);
    const hasPickupOnly = this.hasPickupOnly(cartItems);

    // Prevent invalid switches based on item types
    if (targetMethod === "delivery" && hasPickupOnly) {
      alert("Some items in your cart are pickup only. Please choose Click & Collect.");
      return;
    }

    if (targetMethod === "pickup" && isOnlineOnly) {
      alert("Some items in your cart are online only and cannot be picked up.");
      return;
    }

    const methodElements = this.querySelectorAll("[data-method]");
    methodElements.forEach((element) => {
      if (element.getAttribute("data-method") === targetMethod) {
        element.classList.add("active");
        this.currentMethod = targetMethod;

        const currentState = JSON.parse(localStorage.getItem("clickAndCollectState")) || {};

        if (targetMethod === "pickup") {
          const stores = this.querySelectorAll(".click-collect__store");
          let storeToSelect = currentState.store || (stores.length > 0 ? stores[0].getAttribute("data-store") : null);

          // Update store selection
          stores.forEach((store) => {
            const storeName = store.getAttribute("data-store");
            store.classList.toggle("selected", storeName === storeToSelect);
          });

          // Save updated state with the selected store
          this.updateClickAndCollectState(targetMethod, storeToSelect);

          // Trigger stock check for the selected store
          if (storeToSelect) {
            this.checkCartStockForStore(storeToSelect);
          }
        } else {
          // Delivery branch: keep current store in state (if any)
          this.updateClickAndCollectState(targetMethod, currentState.store || null);

          const savedState = JSON.parse(localStorage.getItem("clickAndCollectState")) || {};
          savedState["cnc-fulfilment-method"] = "";
          savedState["cnc-store-name"] = "";
          savedState["cnc-outlet"] = "";
          savedState["method"] = this.currentMethod;

          localStorage.setItem("clickAndCollectState", JSON.stringify(savedState));
          this.resetCartDrawer();
        }
      } else {
        element.classList.remove("active");
      }
    });
  }

  async handleStoreSelection(store) {
    const stores = this.querySelectorAll(".click-collect__store");
    stores.forEach((s) => s.classList.remove("selected"));

    store.classList.add("selected");

    const storeName = store.getAttribute("data-store");
    // console.log("Selected Store:", storeName);

    this.updateClickAndCollectState(this.currentMethod, storeName);

    await this.checkCartStockForStore(storeName);
  }

  updateClickAndCollectState(method, store = null) {
    const state = { method, store };
    localStorage.setItem("clickAndCollectState", JSON.stringify(state));
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
